"use client";
import Image from "next/image";
import { useEffect } from "react";
import Swiper, { Autoplay } from "swiper";

import Client09 from "@/public/images//tiger_tobaco_tabacaria.jpg";
import Client01 from "@/public/images/bk_tabacaria.jpg";
import Client02 from "@/public/images/farm_tabacaria.jpg";
import Client03 from "@/public/images/gina_tabacaria.jpg";
import Client05 from "@/public/images/gringo_tabacaria.jpg";
import Client06 from "@/public/images/morales_tabacaria.jpg";
import Client07 from "@/public/images/reem_tabacaria.jpg";
import Client08 from "@/public/images/smoke_like_tabacaria.jpg";

// Import Swiper
import "swiper/swiper.min.css";
Swiper.use([Autoplay]);

export default function Clients() {
  useEffect(() => {
    new Swiper(".clients-carousel", {
      slidesPerView: "auto",
      spaceBetween: 64,
      centeredSlides: true,
      loop: true,
      speed: 5000,
      noSwiping: true,
      noSwipingClass: "swiper-slide",
      autoplay: {
        delay: 0,
        disableOnInteraction: true,
      },
    });
  }, []);

  return (
    <section>
      <div className='relative max-w-6xl mx-auto px-4 sm:px-6'>
        <div className='py-12 md:py-16'>
          <div className='overflow-hidden'>
            {/* Carousel built with Swiper.js [https://swiperjs.com/] */}
            {/* * Custom styles in src/css/additional-styles/theme.scss */}
            <div className='clients-carousel swiper-container relative before:absolute before:inset-0 before:w-32 before:z-10 before:pointer-events-none before:bg-gradient-to-r before:from-slate-900 after:absolute after:inset-0 after:left-auto after:w-32 after:z-10 after:pointer-events-none after:bg-gradient-to-l after:from-slate-900'>
              <div className='swiper-wrapper !ease-linear select-none items-center'>
                {/* Carousel items */}
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client01}
                    alt='Client 01'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client02}
                    alt='Client 02'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client03}
                    alt='Client 03'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client05}
                    alt='Client 05'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client06}
                    alt='Client 06'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client07}
                    alt='Client 07'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client08}
                    alt='Client 08'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
                <div className='swiper-slide !w-auto'>
                  <Image
                    className='rounded-2xl'
                    src={Client09}
                    alt='Client 09'
                    width={100}
                    height={100}
                    unoptimized={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
